export const PERCENTAGE = '0';
export const AMOUNT = '1';
